/* eslint-disable */
<template>
  <div class="settings">
    <AdminNavigation ref="navigation" indexProps="9"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Marketing Popups</h1></div>
        <div class="header-sub-title"></div>
      </div>
    </div>
    <div class="panel">
      <AdminSettingsMenu indexProps="16"/>
      <div class="content">
        <div class="tool-bar row">
          <div class="col d-flex justify-content-end">
            <el-input style="max-width: 180px" class="mr-1" @input="search()" clearable placeholder="Title"
                      v-model="listParam.Title"/>
            <el-input style="max-width: 180px" class="mr-1" @input="search()" clearable placeholder="Message"
                      v-model="listParam.Message"/>
            <v-btn class="ml-2" dark @click="tapAddNew()">+ Add</v-btn>
          </div>
        </div>
        <div class="content-scroll-x">
          <el-table :data="records" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}"
                    :header-cell-style="{fontWeight: 100}">
            <el-table-column
                width="140"
                prop="Title"
                label="Title"
                show-overflow-tooltip
                fixed="left"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                label="Message"
                prop="Message"
            >
            </el-table-column>
            <el-table-column
                width="160"
                show-overflow-tooltip
                label="Updated Time"
                prop="UpdatedTime"
            >
              <template slot-scope="item">
                <span>{{ getDate(item.row.UpdatedTime) }}</span>
              </template>
            </el-table-column>
            <el-table-column
                width="140"
                show-overflow-tooltip
                label="Client Category"
                prop="ClientCategory"
            >
              <template slot-scope="item">
                <span>{{ item.row.MarketPopupCriteria.ClientCategory }}</span>
              </template>
            </el-table-column>
            <el-table-column
                width="140"
                show-overflow-tooltip
                label="Client Alignment"
                prop="ClientAlignment"
            >
              <template slot-scope="item">
                <span>{{ item.row.MarketPopupCriteria.ClientAlignment }}</span>
              </template>
            </el-table-column>
            <el-table-column
                width="140"
                show-overflow-tooltip
                label="Client State"
                prop="ClientState"
            >
              <template slot-scope="item">
                <span>{{ item.row.MarketPopupCriteria.ClientState }}</span>
              </template>
            </el-table-column>
            <el-table-column
                width="200"
                show-overflow-tooltip
                label="Active Date"
                prop="StartDate"
            >
              <template slot-scope="item">
                <span>
                  {{ formatDate(item.row.StartDate, 'DD/MM/YYYY', "YYYY-MM-DD HH:mm:ss.ssssss") }} ~
                  {{formatDate(item.row.EndDate, 'DD/MM/YYYY', "YYYY-MM-DD HH:mm:ss.ssssss")}}
                </span>
              </template>
            </el-table-column>
            <el-table-column
                width="100"
                show-overflow-tooltip
                label="IsActive"
                prop="IsActive"
            >
              <template slot-scope="item">
                <el-switch
                    class="ml-2"
                    :value="!!item.row.IsActive"
                    active-color="#13ce66"
                    @change="onChangeActive($event, item)"
                    inactive-color="#E0E0E0">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column
                width="180"
                label="Action"
            >
              <template slot-scope="item">
                <el-button size="small" link @click="handleClickModal(item.row)">Edit</el-button>
                <el-button size="small" link type="danger" @click="handleDelete(item.row)">Delete</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="totalCount > listParam.pageSize" class="pagination">
            Page
            <div class="pagination-group">
              <div class="border-icon pagination-current dropdown">
                <div class="pagination-current-text">{{ listParam.pageNum }}</div>
                <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                     aria-expanded="false"></div>
                <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                  <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                       :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
            <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        top="5vh"
        :close-on-click-modal="false"
        :title="!curItem.MarketPopupID ? 'Create Marketing Popup Message' : 'Edit Marketing Popup Message'"
        :visible.sync="dialogVisible"
        width="40%">
      <el-form :model="curItem" :rules="rules" ref="curItem" label-width="140px" class="demo-curItem">
        <el-form-item label="Title" prop="Title">
          <el-input placeholder="Title" v-model="curItem.Title"></el-input>
        </el-form-item>
        <el-form-item label="Message" prop="Message">
          <el-input placeholder="Message" v-model="curItem.Message" type="textarea" />
        </el-form-item>
        <el-form-item label="Client Category" prop="ClientCategory">
          <el-select :clearable="true" multiple placeholder="Choose client billing category" v-model="curItem.ClientCategory">
            <el-option v-for="category in categories" :key="category.value" :value="category.text" :label="category.text">
              {{ category.text }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Client Alignments" prop="ClientAlignment">
          <el-select :clearable="true" multiple placeholder="Choose client alignment" v-model="curItem.ClientAlignment">
            <el-option v-for="clientAlignment in clientAlignments" :key="clientAlignment.value" :value="clientAlignment.value" :label="clientAlignment.text">
              {{ clientAlignment.text }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Client State" prop="ClientState">
          <el-select :clearable="true" v-model="curItem.ClientState">
            <el-option v-for="(state, index) in states" :value="state.value" :key="index" :label="state.text">{{ state.text }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Start Date" prop="StartDate">
          <el-date-picker
              v-model="curItem.StartDate"
              placeholder="Cancel Date"
              popper-class="date-range-picker-popper"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              end-placeholder="Start Date"
              clearable/>
        </el-form-item>
        <el-form-item label="End Date" prop="EndDate">
          <el-date-picker
              v-model="curItem.EndDate"
              placeholder="End Date"
              popper-class="date-range-picker-popper"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              end-placeholder="Start Date"
              clearable/>
        </el-form-item>
        <el-form-item>
          <span class="dialog-footer d-flex float-right">
    <el-button @click="cancelModal">Cancel</el-button>
    <el-button type="primary" @click="onSave()">Save</el-button>
  </span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSettingsMenu from '@/components/AdminSettingsMenu'
import Header from '@/components/Header'
import {debounce} from 'lodash';

export default {
  name: 'AdminManageEmail',
  components: {
    AdminNavigation,
    AdminSettingsMenu,
    Header,
  },
  data() {
    return {
      rules: {
        Title: [
          { required: true, message: 'Please fill title', trigger: 'blur' }
        ],
        Message: [
          { required: true, message: 'Please fill message', trigger: 'blur' }
        ],
      },
      categories: [],
      clientAlignments: [],
      states: utilities.getStates(),
      option: {
        plugins: 'link image code table',
        height: 400,
        branding: false,
        menu: false,
        browser_spellcheck: true
      },
      editingID: null,
      curValue: null,
      content: '',
      hasError: false,
      records: [],
      dialogVisible: false,
      successMessage: '',
      mode: 'create',
      totalCount: 0,
      curItem: {
        Title: "",
        Message: "",
        StartDate: "",
        EndDate: "",
        ClientCategory: "",
        ClientAlignment: "",
        ClientState: ""
      },
      listParam: {
        pageNum: 1,
        pageSize: 10,
        Message: null,
        Title: '',
        IsActive: null
      },
      MessageType: [{
        name: 'RH2',
        value: 0
      }, {
        name: 'Client Contact',
        value: 1
      }, {
        name: 'Specialist',
        value: 2
      }, {
        name: 'Examinee',
        value: 3
      }, {
        name: 'Custom',
        value: 4
      }],
      fieldList: utilities.getStaticTemplateParam(),
      editorOptions: {
        lineHeight: 1
      }
    }
  },
  computed: {
    validateTemplateName() {
      return this.curItem.EmailTemplateName.trim() !== ''
    },
    validateSubject() {
      return this.curItem.Subject.trim() !== ''
    },
    validateEmailBody() {
      return this.curItem.Body.trim() !== ''
    },
  },
  methods: {
    formatDate(date, format = "YYYY-MM-DD", currentFormat = "YYYY-MM-DD") {
      if (date && date.indexOf('0000-00-00') < 0) {
        return utilities.formatDate(date, format, currentFormat)
      }
      return ""
    },
    tapAddNew() {
      this.curItem = {
        Title: "",
        Message: "",
        StartDate: "",
        EndDate: "",
        ClientCategory: "",
        ClientAlignment: "",
        ClientState: "",
        IsActive: 1
      }
      this.editingID = null
      this.dialogVisible = true
    },
    async onChangeActive(v, row) {
      await this.$store.dispatch("loading/setLoadComponent", true)
      const p = {
        IsActive: v ? 1 : 0
      }
      await utilities.putMarketingPopup(row.row.MarketPopupID, p)
      this.records[row.$index].IsActive = v ? 1 : 0
      await this.$store.dispatch("loading/setLoadComponent", false)
    },
    getDate(v) {
      return window.moment(v).format('DD/MM/YYYY HH:mm')
    },
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    handleDelete(item) {
      this.$confirm({
        content: 'Are you sure you want to delete this one',
        onConfirm: async () => {
          await this.$store.dispatch("loading/setLoadComponent", true)
          await utilities.deleteMarketingPopup(item.MarketPopupID)
          await this.$store.dispatch("loading/setLoadComponent", false)
          this.selectPage(1)
        }
      })
    },
    async onSave() {
      this.$refs['curItem'].validate(async (valid) => {
        if (valid) {
          await this.$store.dispatch("loading/setLoadComponent", true)
          let obj = {...this.curItem}
          if(obj.ClientCategory) {
            obj.ClientCategory = obj.ClientCategory.join(',')
          }
          if(obj.ClientAlignment) {
            obj.ClientAlignment = obj.ClientAlignment.join(',')
          }
          if(this.editingID) {
            await utilities.putMarketingPopup(this.editingID, obj)
            await this.loadData()
          } else {
            await utilities.postMarketingPopup(obj)
            this.selectPage(1)
          }
          await this.$store.dispatch("loading/setLoadComponent", false)
          this.cancelModal()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancelModal() {
      this.$refs['curItem'].resetFields();
      this.dialogVisible = false
      this.curItem = {
        Title: "",
        Message: "",
        StartDate: "",
        EndDate: "",
        ClientCategory: "",
        ClientAlignment: "",
        ClientState: ""
      }
      this.editingID = null
    },
    handleClickModal(item) {
      this.curItem = {
        Title: item.Title,
        Message: item.Message,
        StartDate: window.moment(item.StartDate).format('YYYY-MM-DD'),
        EndDate: window.moment(item.EndDate).format('YYYY-MM-DD'),
        ClientCategory: item.MarketPopupCriteria.ClientCategory ? item.MarketPopupCriteria.ClientCategory.split(',') : [],
        ClientAlignment: item.MarketPopupCriteria.ClientAlignment ? item.MarketPopupCriteria.ClientAlignment.split(',') : [],
        ClientState: item.MarketPopupCriteria.ClientState
      }
      this.editingID = item.MarketPopupID
      this.dialogVisible = true
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadData()
    },

    async loadData() {
      let obj = {...this.listParam}
      for (let key in obj) {
        if (obj[key] === null || obj[key] === '') {
          delete obj[key];
        }
      }
      await this.$store.dispatch("loading/setLoadComponent", true)
      try {
        const {data, total} = await utilities.getMarketingPopups(obj)
        this.totalCount = total
        this.records = data
        await this.$store.dispatch("loading/setLoadComponent", false)
      } catch (e) {
        this.records = []
        this.totalCount = 0
        await this.$store.dispatch("loading/setLoadComponent", false)
      }

    },
  },
  async beforeMount() {
    await this.loadData()
    this.categories = utilities.getClientCategories()
    this.clientAlignments = utilities.getClientAlignments()
  },
  mounted() {
  },
}
</script>
